module.exports = __webpack_public_path__ + "media/icons/google_icon_light_normal-330a2dc7.svg";